if (!customElements.get('quantity-tiers')) {
  customElements.define(
    'quantity-tiers',
    class QuantityTiers extends HTMLElement {
      connectedCallback() {
        this.inputs = Array.from(this.querySelectorAll('.quantity-tiers__input'));
        if (!this.inputs.length) return;

        this.onChange = this.apply.bind(this);
        this.inputs.forEach((input) => input.addEventListener('change', this.onChange));
        this.apply();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, () => this.apply());
        }
      }

      disconnectedCallback() {
        if (this.unsubscribeVariantChange) this.unsubscribeVariantChange();
      }

      get selected() {
        return this.inputs.find((input) => input.checked) || this.inputs[0];
      }

      get quantityInput() {
        return (
          document.querySelector(`.quantity__input[form="${this.dataset.formId}"]`) ||
          this.querySelector('.quantity-tiers__quantity')
        );
      }

      get submitButton() {
        return document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
      }

      apply() {
        const selected = this.selected;
        if (!selected) return;
        const quantity = parseInt(selected.value, 10) || 1;

        const quantityInput = this.quantityInput;
        if (quantityInput && parseInt(quantityInput.value, 10) !== quantity) {
          quantityInput.value = quantity;
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const button = this.submitButton;
        const label = button ? button.querySelector('span') : null;
        if (button && label && !button.disabled && selected.dataset.buttonLabel) {
          label.textContent = selected.dataset.buttonLabel;
        }
      }
    }
  );
}
